import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.menuTarget.classList.add("hidden")
    }
  }

  connect() {
    this._closeHandler = this.close.bind(this)
    this._escapeHandler = this.closeOnEscape.bind(this)
    document.addEventListener("click", this._closeHandler)
    document.addEventListener("keydown", this._escapeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._closeHandler)
    document.removeEventListener("keydown", this._escapeHandler)
  }
}
